import React, { useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { GameScenes, MobileWrapper, popupStore } from '@pascal/pascal-core';
import { applicationStore, platformMessageStore } from '@pascal/pascal-core/shared/core/store';

import { globalTranslationKeys } from '../../enums';
import { ActiveGameScene } from './activeGameScene';
import { PopupsWrapper } from '../../components/common';
import { useDemoSwitcher } from '../../hooks/useDemoSwitcher';
import navBet from '../../assets/images/core/navigation/menu-bet.svg';
import navInfo from '../../assets/images/core/navigation/menu-info.svg';
import navChat from '../../assets/images/core/navigation/menu-chat.svg';
import navGame from '../../assets/images/core/navigation/menu-game.svg';
import navResult from '../../assets/images/core/navigation/menu-result.svg';
import navBetColor from '../../assets/images/core/navigation/menu-bet-color.svg';
import navInfoColor from '../../assets/images/core/navigation/menu-info-color.svg';
import navChatColor from '../../assets/images/core/navigation/menu-chat-color.svg';
import navStatistics from '../../assets/images/core/navigation/menu-statistics.svg';
import navGameColor from '../../assets/images/core/navigation/menu-game-color.svg';
import navResultColor from '../../assets/images/core/navigation/menu-result-color.svg';
import navStatisticsColor from '../../assets/images/core/navigation/menu-statistics-color.svg';
import playForRealPopupImgSrc from '../../assets/images/core/play-for-real-popup.png';
import MobileGame from './mobileGame';

export const MobileMainWrapper = observer(() => {
  const { demoSwitcherAdditionalFunction } = useDemoSwitcher();
  const { isDemo } = applicationStore;
  const { setIsOpenBetHistorySection, isOpenBetHistorySection, isOpenOddsSection, isOpenGameHelpSection } =
    platformMessageStore;
  const [gameScene, setGameScene] = useState(null);

  const { Game, Bet, Result, Info, Chat, Statistics } = globalTranslationKeys;

  const handleGameSceneChange = (clickedScene) => {
    if (clickedScene !== GameScenes.Info) {
      if (isOpenOddsSection) {
        platformMessageStore.setIsOpenOddsSection(false);
      }

      if (isOpenGameHelpSection) {
        platformMessageStore.setIsOpenGameHelpSection(false);
      }
    }

    if (clickedScene !== GameScenes.Bets && isOpenBetHistorySection) {
      setIsOpenBetHistorySection(false);
    }
    popupStore.close();
    setGameScene(clickedScene);

    if (clickedScene === GameScenes.Info) {
      setTimeout(() => {
        popupStore.open();
      }, 0);
    }
  };

  const navItemsPropsArr = useMemo(() => {
    let navItems = [
      {
        text: Game,
        activeImageSrc: navGameColor,
        inActiveImageSrc: navGame,
        isActive: !gameScene,
        onClick: () => {
          handleGameSceneChange(null);
        },
        isCommon: true,
      },
      {
        text: Statistics,
        scene: GameScenes.Statistics,
        activeImageSrc: navStatisticsColor,
        inActiveImageSrc: navStatistics,
        isActive: gameScene === GameScenes.Statistics,
        onClick: () => handleGameSceneChange(GameScenes.Statistics),
      },
      {
        text: Bet,
        scene: GameScenes.Bets,
        activeImageSrc: navBetColor,
        inActiveImageSrc: navBet,
        isActive: gameScene === GameScenes.Bets,
        isCommon: true,
        onClick: () => {
          handleGameSceneChange(GameScenes.Bets);
        },
      },
      {
        text: Result,
        scene: GameScenes.Results,
        activeImageSrc: navResultColor,
        inActiveImageSrc: navResult,
        isActive: gameScene === GameScenes.Results,
        onClick: () => handleGameSceneChange(GameScenes.Results),
      },
      {
        text: Info,
        scene: GameScenes.Info,
        activeImageSrc: navInfoColor,
        inActiveImageSrc: navInfo,
        isActive: gameScene === GameScenes.Info,
        onClick: () => handleGameSceneChange(GameScenes.Info),
      },
    ];

    if (!isDemo) {
      navItems = [
        ...navItems,
        {
          text: Chat,
          scene: GameScenes.Chat,
          activeImageSrc: navChatColor,
          inActiveImageSrc: navChat,
          isActive: gameScene === GameScenes.Chat,
          onClick: () => handleGameSceneChange(GameScenes.Chat),
        },
      ];
    }

    return navItems;
  }, [gameScene, isDemo]);

  return (
    <MobileWrapper
      hasChat
      isShowIconTag
      hasFreeBets
      isShowBogLineLobby
      hasGameTypeLoading
      // navigationVersion2Ui
      navItemsPropsArr={navItemsPropsArr}
      handleGameSceneChange={handleGameSceneChange}
      demoSwitcherAdditionalFunction={demoSwitcherAdditionalFunction}
      playForRealPopupImgSrc={playForRealPopupImgSrc}
    >
      <div className={`mobile-game_wrapper ${gameScene ? 'hidden' : ''}`}>
        <MobileGame />
      </div>
      {gameScene && <ActiveGameScene gameScene={gameScene} />}
      <PopupsWrapper />
    </MobileWrapper>
  );
});
